export function areSignedUrlsEqual(urlA?: string, urlB?: string): boolean {
  if (!urlA || !urlB) return false;

  const parsedUrlA = new URL(urlA);
  const parsedUrlB = new URL(urlB);

  return (
    parsedUrlA.origin === parsedUrlB.origin &&
    parsedUrlA.pathname === parsedUrlB.pathname
  );
}

export function pathStartsWithDirectory(
  sourceUrl: string,
  referenceUrl: string,
): boolean {
  try {
    const sourcePath = new URL(sourceUrl).pathname;
    const refPath = new URL(referenceUrl).pathname;
    const refDir = refPath.substring(0, refPath.lastIndexOf('/'));
    return sourcePath.startsWith(refDir);
  } catch {
    return false;
  }
}
